import React, { useContext, useMemo, useState } from 'react';
import { MdOutlineEdit, MdDriveFileMoveOutline } from 'react-icons/md';
import { RiDeleteBinLine, RiFolderZipLine } from 'react-icons/ri';
import CloseIcon from '@mui/icons-material/Close';
import { PiShareFatLight } from 'react-icons/pi';
import { TbDownload } from 'react-icons/tb';
import '../style.css';
import { DialogContent, IconButton, Tooltip } from '@mui/material';
import { LanguageContext } from '../../../libs/Context';
import ReactPlayer from 'react-player';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import { useDispatch } from 'react-redux';
import { setDownloadFile, setZipFile } from '../../../redux/MediakitRedux';
import MoveToFolder from '../components/MoveToFolder';
import MoveToTrashPopUp from './MoveToTrashPopUp/MoveToTrashPopUp';
import { useParams } from 'react-router-dom';
import RenameFolder from '../components/ListGridViews/components/RenamePopUp';
import EditBrshSvg from '../../../assets/SvgComponents/EditBrshSvg';
import ReactDOM from 'react-dom';
import SelectTemplate from '../components/CustomEdmTemplates/SelectTemplate';

const Preview = (props:any) =>
{
	const { previewOpen, setPreviewOpen, openShare, data, tab } = props;
	const { language } = useContext(LanguageContext);
	const dispatch = useDispatch();
	const clickDownload = () => { dispatch(setDownloadFile([ previewOpen ])); };
	const handleZippedFile = () => { dispatch(setZipFile([ previewOpen ])); };
	const [ popups, setPopups ] = useState<any>(
		{
			move      : false,
			trash     : false,
			rename    : false,
			customize : false
		}
	);
	const [ update, setUpdate ] = useState<any>({});
	const imageCheck = previewOpen?.type === 1 && previewOpen?.media?.type && previewOpen?.media?.type?.split('/')[0] === 'image';
	const clickedUser = useParams()?.userId || '';

	const handlePopup = (item) =>
	{
		setPopups({ ...popups, ...item });
	};

	const show = {
		edit        : (imageCheck && ((tab === 0) || (tab === 2))) || tab === 4,
		share       : (tab === 0 || (tab === 2)),
		zip         :	[ 0, 1, 2 ].includes(tab) && !previewOpen?.media?.type?.match('zip'),
		moveto      :	tab === 0 || tab === 2,
		rename      : tab === 0 || tab === 2,
		movetotrash : [ 0, 2, 4 ].includes(tab),
		download   	: [ 0, 1, 2 ].includes(tab)
	};

	const renderedMedia = useMemo(() =>
	{
		const mediaType = previewOpen?.media?.type?.split('/')?.[0];

		if (mediaType === 'video')
		{
			return (
				<ReactPlayer
					url={previewOpen?.media?.url}
					type='video/mp4'
					controls
					width={'var(--percent100)'}
					height={'var(--percent100)'}
				/>
			);
		}
		else if (mediaType === 'audio')
		{
			return <audio src={previewOpen?.media?.url} controls />;
		}
		else if (mediaType === 'image')
		{
			return (
				<img
					src={previewOpen?.media?.url || data?.media?.url}
					alt='preview'
					loading='lazy'
				/>
			);
		}
		else
		{
			return (
				<DialogContent className='dialogContent508 fullHeight'>
					<div className='mediaDocBackground'>
						<DocViewer
							className='docViewCntr'
							pluginRenderers={DocViewerRenderers}
							documents={[ {
								uri      : previewOpen?.media?.url,
								fileType : previewOpen?.media?.key?.split('.').pop()
							}
							]}
						/>
					</div>
				</DialogContent>
			);
		}
	}, [ previewOpen?.media?.url ]);

	return (
		ReactDOM.createPortal(<>
			<div className='flexCol alignCntr justifyCntr mediaPreview'>
				<div className='resColRow btnWidth pdngBSM'>
					<div className='flexGrow'>
						<div className='hideScrollX'>
							<div className='flexInline pdngSM'>
								<span className='whiteTxt  titleHeading headingLG pdngRSM'>
									{Object.keys(update)?.length > 0 ? update?.name : previewOpen?.name}
								</span>
								{show?.rename && <MdOutlineEdit className='whiteTxt pointer' fontSize='var(--pixel22)' title={language?.rename} onClick={() => handlePopup({ rename: true })}/>}
							</div>
						</div>
					</div>
					<div className='flexGrow hideScrollX'>
						<div className='flexMinWidthRow hideScrollX mediakitjustifyEnd'>
							{show?.edit &&
							<Tooltip title={language.customize}>
								<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ customize: true }); }} className='flexAutoRow  pdngHXS' onClick={() => handlePopup({ customize: true })}>
									<div
										className='flexInline whiteTxt alignCntr justifyCntr pointer mediaBtns'
									>
										<EditBrshSvg className='invertWhite' />
									</div>
								</button>
							</Tooltip>}
							{show?.download &&
							<>
								<Tooltip title={language.download}>
									<button onKeyUp={(e) => { e.key === 'Enter' && clickDownload(); }} className='flexAutoRow pdngHXS' onClick={clickDownload}>
										<div className='flexInline alignCntr justifyCntr pointer mediaBtns'>
											<TbDownload className='whiteTxt' fontSize='var(--pixel22)' />
										</div>
									</button>
								</Tooltip>
								{show?.share &&
								<Tooltip title={language.share}>
									<button className='flexAutoRow pdngHXS' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openShare(e, previewOpen); }} onClick={(e) => openShare(e, previewOpen)}>
										<div className='flexInline alignCntr justifyCntr pointer mediaBtns'>
											<PiShareFatLight className='whiteTxt' fontSize='var(--pixel22)' />
										</div>
									</button>
								</Tooltip>}
								{show?.zip &&
								<Tooltip title={language.zip}>
									<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleZippedFile(); }} className='flexAutoRow pdngHXS' onClick={handleZippedFile}>
										<div className='flexInline alignCntr justifyCntr pointer mediaBtns'>
											<RiFolderZipLine className='whiteTxt' fontSize='var(--pixel22)' />
										</div>
									</button>
								</Tooltip>
								}
								{show?.moveto &&
								<Tooltip title={language?.moveto} >
									<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ move: true }); }} className='flexAutoRow pdngHXS' onClick={() => handlePopup({ move: true })}>
										<div className='flexInline alignCntr justifyCntr pointer mediaBtns'>
											<MdDriveFileMoveOutline
												className='whiteTxt'
												fontSize='var(--pixel22)'
											/>
										</div>
									</button>
								</Tooltip>}
								{show?.movetotrash &&
								<Tooltip title={language?.moveToTrash} >
									<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ trash: true }); }} className='flexAutoRow pdngHXS' onClick={() => handlePopup({ trash: true })}>
										<div className='flexInline alignCntr justifyCntr pointer mediaBtns'>
											<Tooltip title={language?.delete} placement='top'>
												<IconButton>
													<RiDeleteBinLine className='whiteTxt' fontSize='var(--pixel22)' />
												</IconButton>
											</Tooltip>
										</div>
									</button>
								</Tooltip>}
							</>
							}
							<Tooltip title={language.close} >
								<div className='flexAutoRow pdngLSM'>
									<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && setPreviewOpen({ ...previewOpen, open: false }); }}
										className='flexInline alignCntr justifyCntr pointer mediaBtns'
										onClick={() => setPreviewOpen({ ...previewOpen, open: false })}
									>
										<CloseIcon className='whiteTxt' />
									</button>
								</div>
							</Tooltip>
						</div>
					</div>
				</div>
				<div className='flexRow mediaPreviewParent alignCntr justifyCntr'>
					<div className='flexRow mediaPreviewChild alignCntr justifyCntr brdrRadiusXSM' >
						{renderedMedia}
					</div>
				</div>
			</div>
			{popups?.trash &&
			<MoveToTrashPopUp folderData={previewOpen} handlePopup={handlePopup}
				handleClosePreview={() => setPreviewOpen({ ...previewOpen, open: false })}
				type={0}
			/>}
			{popups?.move &&
			<MoveToFolder handlePopup={handlePopup} popups={popups} optionsData={previewOpen}/>
			}
			{popups?.rename && <RenameFolder handlePopup={handlePopup} renameData={previewOpen} popups={popups} from='preview' setUpdate={setUpdate} setRenameData={setPreviewOpen}/>}
			{popups?.customize && <SelectTemplate handlePopup={handlePopup} popups={popups?.customize} from='edit' data={data} clickedUser={clickedUser}/>}
		</>
		, document.body)
	);
};

export default Preview;
